var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { EditBase, SaveButton, SimpleForm, useNotify, useRefresh, } from "react-admin";
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { UPDATE_TEMPLATE } from "@/queries/UpdateTemplate";
import { TemplateFormContent } from "./TemplateFormContent";
export var TemplateEdit = function (props) {
    var id = props.id, close = props.close;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var notify = useNotify();
    var refresh = useRefresh();
    var UpdateTemplate = useMutation(UPDATE_TEMPLATE)[0];
    var _a = React.useState(false), saveEnabled = _a[0], setSaveEnabled = _a[1];
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var aliasValue, _a, updated, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    aliasValue = data.template.alias;
                    return [4 /*yield*/, UpdateTemplate({
                            variables: {
                                id: id,
                                tenantId: tenantId,
                                set: {
                                    alias: aliasValue,
                                    annotations: data.annotations,
                                    communication_method: data.communication_method,
                                    created_at: data.created_at,
                                    created_by: data.created_by,
                                    labels: data.labels,
                                    template: __assign(__assign({}, data.template), { alias: aliasValue }),
                                    tenant_id: data.tenant_id,
                                    type: data.type,
                                    updated_at: data.updated_at,
                                },
                            },
                        })];
                case 1:
                    _a = _b.sent(), updated = _a.data, errors = _a.errors;
                    if (updated) {
                        notify(t("template.update.success"), { type: "success" });
                    }
                    if (errors) {
                        notify(t("template.update.error"), { type: "error" });
                    }
                    close === null || close === void 0 ? void 0 : close();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSuccess = function (res) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            refresh();
            notify("Area updated", { type: "success" });
            if (close) {
                setTimeout(function () {
                    close();
                }, 400);
            }
            return [2 /*return*/];
        });
    }); };
    var onError = function (res) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("onError :>> ", res);
            refresh();
            notify("Could not update Area", { type: "error" });
            if (close) {
                setTimeout(function () {
                    close();
                }, 400);
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsx(EditBase, { id: id, resource: "sequent_backend_template", mutationMode: "pessimistic", mutationOptions: { onSuccess: onSuccess, onError: onError }, redirect: false, children: _jsx(PageHeaderStyles.Wrapper, { children: _jsx(SimpleForm, { onSubmit: onSubmit, toolbar: _jsx(SaveButton, { alwaysEnable: saveEnabled }), children: _jsx(TemplateFormContent, { isTemplateEdit: true, onFormChanged: function () { return setSaveEnabled(true); } }) }) }) }));
};
